module.exports = __webpack_public_path__ + "static/testimonials-bg.d811abc5.webp";